import useLanguage from "../i18n/useLanguage";
import LanguageSwitcher from "./LanguageSwitcher";
import React, { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { Link } from "react-router-dom";

export default function Navbar() {
  const { t, href, basePath } = useLanguage();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isHomePage = basePath === "/";

  const menus = [
    { name: "Home", to: "/", hash: "#hero" },
    { name: "About", to: "/", hash: "#about" },
    { name: "Services", to: "/", hash: "#services" },
    { name: "Products", to: "/", hash: "#products" },
    { name: "Catalog", to: "/catalog", isRoute: true },
    { name: "Portfolio", to: "/", hash: "#portfolio" },
    { name: "Contact", to: "/", hash: "#contact" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }
  }, [open]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-20 h-20
        transition-all duration-300
        ${
          scrolled || !isHomePage
            ? "bg-black/85 backdrop-blur-md shadow-lg"
            : "bg-transparent"
        }
      `}
    >
      <div className="max-w-6xl mx-auto h-full flex items-center justify-between relative px-4 gap-4">
        {/* Logo and Menu */}
        <div className="flex items-center justify-between flex-1 lg:justify-center min-w-0">
          {/* Logo */}
          <Link to={href("/")}>
            <img
              src="/images/logo/logo.webp"
              alt="Titik Senyap Studio"
              className="h-14 w-auto object-contain mr-6 cursor-pointer"
            />
          </Link>

          {/* Menu Desktop */}
          <ul className="hidden lg:flex items-center gap-5 lg:gap-5 font-normal text-white text-base tracking-wide">
            {menus.map((menu) => {
              if (menu.isRoute) {
                const isActive = basePath === menu.to;
                return (
                  <li key={menu.name}>
                    <Link
                      to={href(menu.to)}
                      className={`transition-colors ${
                        isActive
                          ? "text-amber-300 font-semibold"
                          : "hover:text-gray-300"
                      }`}
                    >
                      {t(menu.name)}
                    </Link>
                  </li>
                );
              }

              const targetHref = isHomePage ? menu.hash : `/${menu.hash}`;
              return (
                <li key={menu.name}>
                  <a
                    href={href(targetHref)}
                    className="hover:text-gray-300 transition-colors"
                  >
                    {t(menu.name)}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <LanguageSwitcher />

        {/* Hamburger (Mobile) */}
        <button
          className="lg:hidden shrink-0 text-3xl font-normal text-white"
          onClick={() => setOpen(!open)}
          aria-label={t("Toggle Menu")}
          aria-expanded={open}
        >
          {open ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div
          className="
    fixed inset-0 top-20
    lg:hidden
    bg-black/95 backdrop-blur-md
    font-normal text-white
    flex flex-col items-center justify-center
    space-y-8
    z-30
  "
        >
          {menus.map((menu) => {
            if (menu.isRoute) {
              const isActive = basePath === menu.to;
              return (
                <Link
                  key={menu.name}
                  to={href(menu.to)}
                  className={`text-xl tracking-wide ${
                    isActive ? "text-amber-300 font-bold" : "hover:text-gray-300"
                  }`}
                  onClick={() => setOpen(false)}
                >
                  {t(menu.name)}
                </Link>
              );
            }

            const targetHref = isHomePage ? menu.hash : `/${menu.hash}`;
            return (
              <a
                key={menu.name}
                href={href(targetHref)}
                className="text-xl tracking-wide hover:text-gray-300"
                onClick={() => setOpen(false)}
              >
                {t(menu.name)}
              </a>
            );
          })}
        </div>
      )}
    </nav>
  );
}
